// extracted by mini-css-extract-plugin
module.exports = {"carouselControls":"CarouselControls_carouselControls__gPRVd","controlsContent":"CarouselControls_controlsContent___3XXK","controlButtons":"CarouselControls_controlButtons__gKO19"};